function IFrameWidget({sSystemName, cMake})
{
    let systemConfig = require('../config/' + sSystemName + '.json');
    let systemCSS = require('../config/' + sSystemName + '.css');

    return (
        <iframe class="expander" src={cMake.sURL} title={cMake.sTitle}></iframe>
    );
}

export default IFrameWidget